module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aversion"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('Update_LOG'),
      "selfMethod": "1"
    },
    on: {
      "leftClick": _vm.goBack
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoList"
  }, [_c('ul', {
    staticClass: "tip",
    staticStyle: {
      "background-color": "#eee",
      "padding": "10px"
    }
  }, [_c('li', [_c('h2', [_vm._v("V1.2.0 (2021-3-18)")])]), _vm._v(" "), _c('li', [_vm._v("1、替换Ios证书为最新版本")])]), _vm._v(" "), _c('ul', {
    staticClass: "tip"
  }, [_c('li', [_c('h2', [_vm._v("V1.0.0 (2020-11-27)")])]), _vm._v(" "), _c('li', [_vm._v("1、去除首页穿透后的楼栋绑定")])]), _vm._v(" "), _c('ul', {
    staticClass: "tip"
  }, [_c('li', [_c('h2', [_vm._v("V1.0.0 (2020-11-27)")])]), _vm._v(" "), _c('li', [_vm._v("初始版本")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-61c9e128","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/huanQiuPage/versionDetailHuanQiu.vue
// module id = 1795
// module chunks = 107